<nav class="container navbar navbar-toggleable-md fixed-top navbar-inverse bg-inverse">
  <button class="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarsDefault"
          aria-controls="navbarsExampleDefault"
          aria-expanded="false"
          aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse"
       id="navbarsDefault">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link transition"
           href="javascript:void(0);"
           data-toggle="offcanvas">
          <i class="fa fa-bars"
             aria-hidden="true"></i></a>
      </li>
      <li class="nav-item">
        <a class="nav-link header-logo"
           href="/">
        </a>
      </li>
    </ul>
    <form class="form-inline header-search">
      <select id="header-search"
              class="form-control">
        <option class="disable-option" disabled="disabled" ></option>
        <option class="search-option"
                selected="selected">Search Type</option>
        <option class="disable-option" disabled="disabled" ></option>
        <div class="dropdown-divider"></div>
        <option class="label-option"
                label="Network Servers"
                disabled>Network Servers</option>
        <option class="disable-option" disabled="disabled" ></option>
        <option class="search-option"
                value="netId">NetID</option>
        <option class="disable-option" disabled="disabled" ></option>
        <option class="search-option"
                value="netId">NSID</option>
        <option class="disable-option" disabled="disabled" ></option>
        <option class="search-option"
                value="netId">Name</option>
        <option class="disable-option" disabled="disabled" ></option>
        <option class="label-option"
                label="Join Servers"
                disabled>Join Servers</option>
        <option class="disable-option" disabled="disabled" ></option>
        <option class="search-option"
                value="joinEui">JoinEUI</option>
        <option class="disable-option" disabled="disabled" ></option>
        <option class="search-option"
                value="joinEui">Name</option>
        <option class="disable-option" disabled="disabled" ></option>

        <!--<optgroup *ngIf="isAdmin == true"-->
                  <!--label="Users">-->
          <!--<option value="users">Username</option>-->
          <!--<option value="users">Affiliation</option>-->
        <!--</optgroup>-->
      </select>

      <input type="text"
             class="form-control"
             id="header-search-text"
             aria-describedby="search"
             placeholder="Search">
      <i class="fa fa-search" aria-hidden="true" id="i-search-text">
      </i>
    </form>
    <ul class="navbar-nav menu-items">
      <li class="nav-item">
        <a class="nav-link"
           href="javascript:void(0);">
          <i class="fa fa-user-o"
             aria-hidden="true">
          </i>
          <span>My Profile</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           href="javascript:void(0);">
          <i class="fa fa-question-circle-o"
             aria-hidden="true">
          </i>
          <span>Help</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           (click)="logout();verifyAdmin()">
          <i class="fa fa-sign-out"
             aria-hidden="true">
          </i>
          <span>Logout</span>
        </a>
      </li>
    </ul>
  </div>
</nav>

